import React from 'react';

const SwedishPage = () => {
    return (
        <div>
            <h3>
                <span lang="sv">Bästa universitetslärare!</span>
            </h3>
            <h3>
                <span lang="sv">
                    Välkommen att använda Reflektionskompassen i undervisningen om forskningsetik!
                </span>
            </h3>

            <p>
                <span lang="sv">
                    Reflektionskompassen är en applikation för att stödja lärare i undervisningen om
                    forskningsetik, och för att stödja studenter i reflekterande lärande med
                    uppgifter relaterade till forskningsetik.
                </span>
            </p>

            <p>
                <span lang="sv">
                    Forskningsetik behandlas inom många olika kurser, till exempel
                    forskningsseminarier, metodikkurser, vetenskapligt skrivande, och seminarier om
                    referentgranskning och publicering. Dessutom är reflektion viktigt i sammanhang
                    som kräver etisk sensitivitet. Det kan var svårt för läraren att veta hur
                    undervisning i forskningsetik inverkar på studerandes vilja att förhålla sig
                    reflektivt och agera enligt god vetenskaplig praxis. Dessutom kan studenter
                    förlita sig på AI-verktyg för att slutföra uppgifter – vilket ofta är okej, men
                    om det görs utan egen tankeverksamhet och reflektion är det tveksamt vad
                    studenterna verkligen har lärt sig. Lärare kan önska att de kunde undvika
                    oönskad användning av AI och samtidigt hålla sig underrättade om studenternas
                    lärandeprocess utan att bli överbelastade med uppgifter att läsa.
                </span>
            </p>

            <h3>
                <span lang="sv">Vad gör applikationen? </span>
            </h3>

            <p>
                <span lang="sv">
                    Vi introducerar ett forskningsbaserat verktyg för universitetslärare som
                    undervisar i forskningsetik. Applikationen är utvecklad av experter på
                    forskningsetik och pedagoger för att hjälpa lärare att{' '}
                </span>
            </p>

            <p>
                <span lang="sv">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="sv">
                    ta reda på vad studenterna lär sig och om deras undervisning är ändamålsenlig;{' '}
                </span>
            </p>

            <p>
                <span lang="sv">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="sv">övervaka hur studenterna förstår kursinnehållet; </span>
            </p>

            <p>
                <span lang="sv">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="sv">
                    genomföra formativ bedömning och ge feedback till studenter under kursens gång;{' '}
                </span>
            </p>

            <p>
                <span lang="sv">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="sv">
                    uppmuntra studenter att vara medvetna om sitt lärande och stödja utvecklingen av
                    deras reflektionsförmåga;{' '}
                </span>
            </p>

            <p>
                <span lang="sv">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="sv">
                    stödja studenter i att lära sig att utvärdera sin egen förståelse och sitt
                    lärande.
                </span>
            </p>

            <h3>
                <span lang="sv">Hur fungerar applikationen? </span>
            </h3>

            <p>
                <span lang="sv">
                    Applikationen vägleder läraren att sätta upp en kurs med uppgifter, varpå
                    läraren kopierar en inbjudan som delas med studenterna. Det är en bra idé att
                    inkludera flera uppgifter i en kurs. Uppgifterna utförs under en tid som bestäms
                    av läraren. Tidsspannet indikera när studenterna kan göra uppgifterna. Lärare
                    kan också duplicera sina kurser och uppgifter och använda dem under kommande
                    terminer. Kurserna ges ett unikt ID som hjälper till att skilja mellan olika år
                    och grupper.
                </span>
            </p>

            <p>
                <span lang="sv">
                    Studenter loggar in med sina inloggningsuppgifter och slår upp den kurs och
                    uppgift som läraren har angett i inbjudningslänken. Uppgifterna består av två
                    moment: först skriver studenten en relativt kort text som svar på lärarens
                    uppgift varpå hen reflekterar över sitt eget kunnande och indikerar sin
                    förståelse genom att välja ett av fem alternativ som bäst beskriver förståelsen.
                    Efter att ha skickat in sitt svar får studenten automatiserad feedback som
                    beskriver den förståelsenivå de har valt. Applikationen uppmuntrar studenterna
                    reflektera över huruvida den förståelsenivå som beskrivs i den automatiserade
                    återkopplingen motsvarar deras egen uppfattning. Studenten kan gå tillbaka till
                    och redigera antingen den egna svarstexten eller förståelsenivån.
                </span>
            </p>

            <p>
                <span lang="sv">
                    Applikationen analyserar de av studenterna själva angivna nivåerna för
                    förståelse och anger resultaten i ett cirkeldiagram till läraren (se figur 1).
                </span>
            </p>

            <p align="center">
                <span lang="sv">
                    <img
                        alt=" Figur 1. Lärarens vy över de av studenterna indikerade nivåerna för förståelse
                    av kursinnehåll."
                        width="500"
                        height="auto"
                        src="/image003.png"
                    />
                </span>
            </p>

            <p>
                <span lang="sv">
                    Figur 1. Lärarens vy över de av studenterna indikerade nivåerna för förståelse
                    av kursinnehåll.
                </span>
            </p>

            <p>
                <span lang="sv">&nbsp;</span>
            </p>

            <p>
                <span lang="sv">
                    Dessutom kan både lärare och studenter se utvecklingen i ett linjediagram (se
                    figur 2).
                </span>
            </p>

            <p align="center">
                <span lang="sv">
                    <img
                        alt="Figur 2. Linjediagram över en students självutvärdering av två uppgifter."
                        width="700"
                        height="auto"
                        src="/image004.png"
                    />
                </span>
            </p>

            <p>
                <span lang="sv">
                    Figur 2. Linjediagram över en students självutvärdering av två uppgifter.
                </span>
            </p>

            <p>
                <span lang="sv">&nbsp;</span>
            </p>

            <p>
                <span lang="sv">
                    Utöver den automatiserade feedbacken som student får via applikationen kan
                    läraren ge mer personligt anpassad feedback i form av skriven text eller genom
                    att ange sin uppskattning av den förståelsenivå som hen anser att studentens
                    text uttrycker.
                </span>
            </p>

            <p>
                <span lang="sv">
                    Användningen av appen stöder främst studenternas reflekterande lärande och
                    formativ bedömning under kursens gång, men diagrammet som visar den enskilda
                    studentens lärandeprocess (se figur 2) fungerar väl som en grund för
                    'reflektionsdagbok'. Diagrammet fungerar som en sammanfattning över
                    lärandeprocessen och kan användas för vidare reflektioner i dagboken.
                    Reflektionsdagboken kan användas för summativ bedömning, det vill säga som en
                    betygsatt uppgift som bidrar till den slutliga bedömningen i kursen.
                </span>
            </p>

            <p>
                <span lang="sv">
                    Upprepad användning av applikationen ger lärare insikter om hur studenterna
                    utvecklas, vilka teman inom forskningsetik som verkar vara mer utmanande och
                    vilka som har bemästrats. Studenterna kan också se sin egen utveckling i
                    diagrammet, och genom att läsa feedbacken som ges av applikationen och
                    eventuellt också läraren, utveckla självutvärderingskompetensen.
                </span>
            </p>

            <p>
                <span lang="sv">&nbsp;</span>
            </p>

            <p>
                <span lang="sv">Förståelsenivåer baserade på SOLO-taxonomin: </span>
            </p>

            <p>
                <span lang="sv">Symbolen </span>
                <span lang="sv">
                    <img
                        alt="Behöver hjälp för att utveckla förståelse"
                        width="12"
                        height="12"
                        src="/image005.png"
                    />
                </span>
                <span lang="sv">
                     indikerar studentens behov av hjälp för att förstå. Studenten kan behöva
                    bekanta sig med central forskningsetiska regelverk och diskutera med erfarna
                    forskare om hur de tänker kring att göra rätt val i forskningen.{' '}
                </span>
            </p>

            <p>
                <span lang="sv">Symbolen </span>
                <span lang="sv">
                    <img alt="Spirande förståelse" width="13" height="13" src="/image006.png" />
                </span>
                <span lang="sv">
                     indikerar spirande förståelse. Studenten uppmuntras att tänka på andra
                    perspektiv som kan tänkas relatera till det studenten redan känner till.
                    Studenten kan till exempel uppmuntras att identifiera vilka som berörs av frågan
                    och sedan granska frågan från berörda parters synvinklar, vilket kan hjälpa
                    studenten att bredda insyn i vad annat som kan ingå i temat/frågan.{' '}
                </span>
            </p>

            <p>
                <span lang="sv">Symbolen </span>
                <span lang="EN-GB">
                    <img alt="Måttlig förståelse" width="17" height="17" src="/image007.png" />
                </span>
                <span lang="sv">
                     indikerar måttlig förståelse. Studenten gynnas av stöd i att försöka se samband
                    mellan olika etiska aspekter i forskningen och tänka på exempel för att beskriva
                    dessa samband.{' '}
                </span>
            </p>

            <p>
                <span lang="sv">Symbolen </span>
                <span lang="EN-GB">
                    <img
                        border="0"
                        width="16"
                        height="16"
                        src="/image008.png"
                        alt="Förståelse för samband"
                    />
                </span>
                <span lang="sv">
                     indikerar förståelse för samband. På den här nivån kan studenten med fördel
                    rekommenderas att tillämpa sina kunskaper i olika sammanhang och stöda/
                    instruera andra.{' '}
                </span>
            </p>

            <p>
                <span lang="sv">Symbolen </span>
                <span lang="EN-GB">
                    <img alt="Djuplodande förståelse" width="19" height="19" src="/image009.png" />
                </span>
                <span lang="sv">
                     indikerar djuplodande förståelse. Studenten uppfattar sin roll i att främja god
                    vetenskaplig praxis och i att upprätthålla en etiskt hållbar handlingskultur.
                </span>
            </p>

            <p>
                <span lang="sv">&nbsp;</span>
            </p>

            <p>
                <span lang="sv">Vilken forskning bygger applikationen på? </span>
            </p>

            <p>
                <span lang="sv">
                    Reflektionskompassen bygger på designprinciper baserade på forsknings samt
                    forskningsresultat. Applikationen utnyttjar{' '}
                    <i>Structure of Observed Learning Outcomes</i> (SOLO) -taxonomin i beskrivningen
                    av nivåerna för förståelse samt i den automatiserade feedbacken. Genom
                    visualiseringarna som applikationen producera och genom att följa med svaren
                    studenterna ger på kursuppgifterna vid olika tidpunkter under kursens gång, kan
                    läraren få en helhetsbild av studenternas lärande samt information om hur
                    undervisningen fungerar.
                </span>
            </p>

            <p>
                <span lang="sv">
                    Genom följande länkar får du mera information om SOLO-taxonomin och forskningen
                    bakom applikationen:{' '}
                </span>
            </p>

            <p>
                <span lang="sv">
                    SOLO-taxonomin:{' '}
                    <a href="https://www.johnbiggs.com.au/academic/solo-taxonomy/">
                        https://www.johnbiggs.com.au/academic/solo-taxonomy/
                    </a>
                </span>
            </p>

            <p>
                <span lang="EN-US">
                    Artikel: John Biggs (1999) What the Student Does: teaching for enhanced
                    learning, Higher Education Research &amp; Development, 18:1, 57-75, DOI:
                    10.1080/0729436990180105
                </span>
            </p>

            <p>
                <span lang="sv">Länk till artikeln:</span>
                <span lang="sv">
                    <a href="https://www.tandfonline.com/doi/pdf/10.1080/0729436990180105">
                        <span lang="sv">
                            https://www.tandfonline.com/doi/pdf/10.1080/0729436990180105
                        </span>
                    </a>
                </span>
            </p>

            <p>
                <span lang="sv">
                    Forskning om självutvärdering och utvecklingen av reflektionsapplikationen:{' '}
                </span>
            </p>

            <p>
                <span lang="EN-US">
                    Artikel: Anu Tammeleht &amp; Erika Löfström (2024) Learners’ self-assessment as
                    a measure to evaluate the effectiveness of research ethics and integrity
                    training: can we rely on self-reports?, <i>Ethics &amp; Behavior</i>, 34:8,
                    575-596, DOI: 10.1080/10508422.2023.2266073{' '}
                </span>
            </p>

            <p>
                <span lang="sv">Länk till artikeln:</span>
                <span lang="sv">
                    <a href="https://www.tandfonline.com/doi/pdf/10.1080/10508422.2023.2266073">
                        <span lang="sv">
                            https://www.tandfonline.com/doi/pdf/10.1080/10508422.2023.2266073
                        </span>
                    </a>
                </span>
                <span lang="sv"> </span>
            </p>

            <p>
                <span lang="sv">Utvecklingen av applikationen har fått stöd av: </span>
            </p>

            <p>
                <span lang="sv">
                    <img alt="Beyond apples logo" width="214" height="auto" src="/image011.png" />
                </span>
                <span lang="sv">
                     {' '}
                    <img alt="European union logo" width="117" height="auto" src="/image012.png" />
                       
                </span>
                <span lang="sv">
                    <img
                        border="0"
                        width="200"
                        height="auto"
                        src="/image013.png"
                        alt="Reimagining Teachers and Teacher Education for our Futures | University of  Helsinki"
                    />
                </span>
            </p>
        </div>
    );
};

export default SwedishPage;
